module.exports = __webpack_public_path__ + "static/media/archibot-dingo.055fb94b.gif";